<script>
  import HeaderWrapper from '../wrappers/HeaderWrapper.svelte';
  import ContentWrapper from '../wrappers/ContentWrapper.svelte';
  import ButtonsWrapper from '../wrappers/ButtonsWrapper.svelte';
  import Purpose from '../elements/Purpose.svelte';
  import CloseIcon from '../elements/CloseIcon.svelte';
  import Button from '../elements/Button.svelte';
  import {_} from '../../translations';
  import {PAGE_VENDORS, PURPOSE_CONTENT, PURPOSE_ADS, USER_INT, USER_EXT} from '../../constants';
  import {logger} from '../../services/logger';

  export let userType = '';
  export let formData = {};
  export let loggedUsr = false;
  export let submiting = false;
  export let userLoggedIn = false;

  const onChangeUpdateFormData = ({target}) => {
    const {checked, value} = target;

    formData.purposes[value] = checked;
    logger(400, `Purpose "${value}" checked value is ${checked}.`);
  };
</script>

<CloseIcon on:exit screen={2} />
<div class="scmp_Scrollable-content-wrapper">
  <HeaderWrapper>
    <div class="scmp_Purpose-header">
      <h2 class="scmp_SectionTitle">{_('purposes.title')}</h2>
      <Button on:buttonClick label={_('button.details')} navigation={PAGE_VENDORS} type="back" customClass="scmp_Button--openVendors" />
    </div>
    <p class="scmp_Paragraph">
      {#if userType === USER_INT}
        {@html _('purposes.description')}
        {#if userLoggedIn}
          {@html _(`purposes.changeSettingsLogged`)}
        {:else}
          {@html _(`purposes.changeSettingsUnlogged`)}
        {/if}
      {/if}
      {#if userType === USER_EXT}
        {@html _('purposes.descriptionExternal')}
      {/if}
    </p>
  </HeaderWrapper>

  <ContentWrapper>
    <Purpose
      on:change={onChangeUpdateFormData}
      id={PURPOSE_CONTENT}
      checked={formData.purposes[PURPOSE_CONTENT]}
      title={_('purposes.personalizeContent.title')}
      text={_('purposes.personalizeContent.description')}
      customClass="scmp_Purpose--first">
      {#if userType === USER_INT}
        {#if loggedUsr}
          {@html _('purposes.personalizeContent.details')}
        {:else}
          {@html _('purposes.personalizeContent.detailsUnlogged')}
        {/if}
      {/if}
      {#if userType === USER_EXT}
        {@html _('purposes.personalizeContent.detailsExternal')}
      {/if}
    </Purpose>
    <Purpose
      on:change={onChangeUpdateFormData}
      id={PURPOSE_ADS}
      checked={formData.purposes[PURPOSE_ADS]}
      title={_('purposes.personalizeAds.title')}
      text={_('purposes.personalizeAds.description')}
      customClass="scmp_Purpose">
      <div>
        {#if userType === USER_INT}
          {#if loggedUsr}
            {@html _('purposes.personalizeAds.details1')}
          {:else}
            {@html _('purposes.personalizeAds.detailsUnlogged1')}
          {/if}
          {_('purposes.personalizeAds.details11')}
          <Button
            on:buttonClick
            screen={2}
            label={_('button.here')}
            type="link"
            customClass="scmp_Button-link--small"
            navigation={PAGE_VENDORS} />
          {_('purposes.personalizeAds.details2')}
          {@html _('purposes.personalizeAds.details22')}
        {/if}
        {#if userType === USER_EXT}
          {@html _('purposes.personalizeAds.detailsExternal')}
        {/if}
      </div>
    </Purpose>
  </ContentWrapper>
</div>

<ButtonsWrapper>
  <Button on:buttonClick screen={2} disabled={submiting} label={_('button.confirm')} type="submit" />
</ButtonsWrapper>
